import AudioManager from "../../../../manager/audio_manager";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;
const const_malePath: string = 'package/bipai/sound/male/'
const const_femalePath: string = 'package/bipai/sound/female/'
const const_effectPath: string = 'package/bipai/sound/'
const const_musicPath: string = 'package/bipai/sound/bgm/'

export default class BiPaiTableSound{
    
    playBgm(){
        let soundName = 'bi_pai_q2'
        this.playMusic(const_musicPath + soundName, soundName)
    }

    playCardTypeSound(male: boolean, count: number, index: number, onFinish?: Function){
        let soundName = count + '_' + index
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playSanTiaoSound(male: boolean, onFinish?: Function){
        let soundName = 'santiao'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playSiTiaoSound(male: boolean, onFinish?: Function){
        let soundName = 'sitiao'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playTongHuaSound(male: boolean, onFinish?: Function){
        let soundName = 'tonghua'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playTongHuaShunSound(male: boolean, onFinish?: Function){
        let soundName = 'tonghuashun'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playHuangJiaTongHuaShunSound(male: boolean, onFinish?: Function){
        let soundName = 'huangjiatonghuashun'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playHuLuSound(male: boolean, onFinish?: Function){
        let soundName = 'hulu'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playShunZiSound(male: boolean, onFinish?: Function){
        let soundName = 'shunzi'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playKaiSound(male: boolean, onFinish?: Function){
        let soundName = 'kaipai'
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playFollowSound(male: boolean, count: number, onFinish?: Function){
        let soundName = 'follow_' + count
        let rootPath = male? const_malePath: const_femalePath
        this.playSound(rootPath + soundName, soundName, onFinish)
    }

    playAddChipEffectSound(onFinish?: Function){
        let soundName = 'fk_add_chip'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playGoldFlyEffectSound(onFinish?: Function){
        let soundName = 'goldFly'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playCompareCardEffectSound(onFinish?: Function){
        let soundName = 'compareCard'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playCompareLoseEffectSound(onFinish?: Function){
        let soundName = 'compareLose'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playCompareWinEffectSound(onFinish?: Function){
        let soundName = 'compareWin'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playDealCardEffectSound(onFinish?: Function){
        let soundName = 'dealCard'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playClockTickEffectSound(onFinish?: Function){
        let soundName = 'fk_clock_wave'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playBombEffectSound(onFinish?: Function){
        let soundName = 'fk_bomb'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playFollowCardEffectSound(onFinish?: Function){
        let soundName = 'fk_follow_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playMultipleChangeEffectSound(onFinish?: Function){
        let soundName = 'fk_multiple_audio'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playMyTurnEffectSound(onFinish?: Function){
        let soundName = 'fk_my_turn'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playPlaneFlyEffectSound(onFinish?: Function){
        let soundName = 'fk_plane_fly'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playPutCardEffectSound(onFinish?: Function){
        let soundName = 'fk_put_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playTakeCardEffectSound(onFinish?: Function){
        let soundName = 'fk_take_card'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playShowCardEffectSound(onFinish?: Function){
        let soundName = 'fkshowCard'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playFlopCardEffectSound(onFinish?: Function){
        let soundName = 'flopCard'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playGameCountEffectSound(onFinish?: Function){
        let soundName = 'gameCount'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playGameStartEffectSound(onFinish?: Function){
        let soundName = 'gameStart'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playRollBombSound(onFinish?: Function){
        let soundName = 'balloon_game_boom'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playGunBombEffectSound(onFinish?: Function){
        // let soundName = 'gunBomb'
        let soundName = '4k_call_bomb'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playSpecialCardEffectSound(onFinish?: Function){
        let soundName = 'specialCard'
        this.playSound(const_effectPath + soundName, soundName, onFinish)
    }

    playSound(fullPath:string, soundName: string, onFinish: Function){
        AudioManager.instance.playSound(fullPath, false, onFinish)
    }

    playMusic(fullPath: string, soundName: string){
        AudioManager.instance.playMusic(fullPath, false)
    }

    stopBgm(){
        AudioManager.instance.stopAllMusic()
    }


    private getRandomIndex(under: number = 0, over: number = 0){
        return Utility.getIntRandom(under, over)
    }
}